import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { DELETE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE, GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE, POST_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE, UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE } from '../../types';
import { deleteClientContractsCreditsAndRebates, getClientContractsCreditsAndRebates, postClientContractsCreditsAndRebates, updateClientContractsCreditsAndRebates } from '../../clients.actions';
import Spinner from 'modules/common/spinner.component';
import CrudTableCard from 'modules/common/crudTableCard.component';
import { formatMoney } from 'utilities/currencyFormatter';
import { enumColumn } from 'modules/common/enumTableColumn';


const styles = (theme) => {
  return {
    row: {
      backgroundColor: theme.palette.common.white,
    },
    accordionStyleContacts: {
      maxWidth: 1050,
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    root: {
      maxWidth: 170,
      marginRight: 10,
    },
    extRoot: {
      width: 115,
      marginRight: 10,
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050,
    },
  };
};

const ClientContractsCreditsAndRebatesTable = (props) => {

  const { clientId, enumerations } = props;

const creditRebateTypes =
    enumerations.clientCreditRebatesTypes && enumerations.clientCreditRebatesTypes.length > 0
      ? enumerations.clientCreditRebatesTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const adjustedColumns = [
    { ...enumColumn('typeId', creditRebateTypes), header: 'Type', type: 'dropdown-v2', options: creditRebateTypes, size: 100, required: true, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },
    { accessorKey: 'amount', header: 'Amount', type: 'money', required: true, size: 100, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, Cell: ({ cell }) => formatMoney(cell.getValue()) },
    { accessorKey: 'description', header: 'Description', type: 'notes', size: 125, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },

  ];

  const updateRow = async (contractsCreditsAndRebates, values) => {
    const id = contractsCreditsAndRebates.original.clientCreditRebateId;
    values.clientCreditRebateId = id;
    values.clientRecordId = clientId;
    const resp = await props.updateClientContractsCreditsAndRebates(values);
    if (resp.type === UPDATE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractsCreditsAndRebates(clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const createRow = async (values) => {
    values.clientRecordId = clientId;
    const resp = await props.postClientContractsCreditsAndRebates(values);
    if (resp.type === POST_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractsCreditsAndRebates(clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const deleteRow = async (contractsCreditsAndRebates) => {
    const id = contractsCreditsAndRebates.original.clientCreditRebateId;
    const resp = await props.deleteClientContractsCreditsAndRebates(id);
    if (resp.type === DELETE_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
      return false;
    } else {
      const getResp = await props.getClientContractsCreditsAndRebates(clientId);
      if (getResp.type === GET_CLIENT_CONTRACT_CREDITS_REBATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const tabs = [{ header: 'Credits & Rebates', order: 1, iconPath: ['fas', 'money-check-dollar'], multiTabComponent: false }];

  const summaries = [
    {
      adjustedColumns: adjustedColumns,
      rows: props.clientContractsCreditsAndRebates ? props.clientContractsCreditsAndRebates : [],
      addButtonText: 'Add Record',
      tab: 1,
      updateRow: updateRow,
      createRow: createRow,
      deleteRow: deleteRow,
      hideEdit: false,
      hideHeader: false,
    }
  ];

  return (
    <>
      {props.clientContractsCreditsAndRebatesLoading && <Spinner />}
      {!props.clientContractsCreditsAndRebatesLoading && <CrudTableCard tabs={tabs} summaries={summaries} numColumns={5} />}
    </>
  );
}; 

ClientContractsCreditsAndRebatesTable.propTypes = {
  classes: PropTypes.object.isRequired,
  clientContractsCreditsAndRebatesLoading: PropTypes.bool,
  clientId: PropTypes.number,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  postClientContractsCreditsAndRebates: PropTypes.func,
  updateClientContractsCreditsAndRebates: PropTypes.func,
  getClientContractsCreditsAndRebates: PropTypes.func,
  deleteClientContractsCreditsAndRebates: PropTypes.func,
  clientContractsCreditsAndRebates: PropTypes.array,
};

const mapStateToProps = (state) => {
  const clientContractsCreditsAndRebates = state.clients.clientsInfo[state.clients.currentClientId]?.clientDetails?.clientCreditRebates;
  const { clientContractsCreditsAndRebatesLoading } = state.clients;
  return {
    clientContractsCreditsAndRebates,
    clientContractsCreditsAndRebatesLoading,
  };
};
  
export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getClientContractsCreditsAndRebates,
    deleteClientContractsCreditsAndRebates,
    postClientContractsCreditsAndRebates,
    updateClientContractsCreditsAndRebates,
  }),
)(ClientContractsCreditsAndRebatesTable);